import { JarvisWebHttpClient } from '@jarvis/web-http'
import { Urls, DriverTypes, UserOs } from '../store/Constants'
import { compareVersions } from '../utils'

export class SwlsDriversClient {
  constructor() {
    this.jarvisWebHttpInstance = new JarvisWebHttpClient()
  }

  async _fetchDriverDownloadUrl(url, driverTypePreference) {
    if (!url) throw new Error('No valid SWLS URL for provided parameters')
    if (!driverTypePreference || !driverTypePreference.length) {
      throw new Error('driverTypePreference is required')
    }

    const response = await this.jarvisWebHttpInstance.get({ url })
    const basicDrivers = new Map()
    for (const entry of response.data) {
      const driverType = entry['Type']?.toUpperCase()
      if (driverTypePreference.includes(driverType)) {
        if (basicDrivers.has(driverType)) {
          const storedVersion = basicDrivers.get(driverType).version
          const currentVersion = entry['Version']
          if (compareVersions(storedVersion, currentVersion) < 0) {
            basicDrivers.set(driverType, {
              url: entry['FtpURL'].replace('ftp://', 'https://'),
              version: entry['Version']
            })
          }
        } else {
          basicDrivers.set(driverType, {
            url: entry['FtpURL'].replace('ftp://', 'https://'),
            version: entry['Version']
          })
        }
      }
    }
    let workingUrl
    for (const driverType of driverTypePreference) {
      if (basicDrivers.has(driverType)) {
        workingUrl = basicDrivers.get(driverType).url
        break
      }
    }
    if (!workingUrl) {
      throw new Error('No driver found')
    }
    return workingUrl
  }

  /**
   * Returns best driver download URL for a given SKU using provided driver type preference.
   */
  async getDriverDownloadUrl(sku, driverTypePreference) {
    if (!sku) throw new Error('SKU is required for getDriverDownloadUrl')
    const url = Urls.swls(sku)
    return this._fetchDriverDownloadUrl(url, driverTypePreference)
  }

  /**
   * Returns best driver download URL for supported OS (Windows/Mac) with automatic driver type preference.
   */
  async getDriverDownloadUrlByOS(os, easystartpro = false) {
    const url = Urls.swlsNoSku(os, easystartpro)
    const driverTypePreference =
      os === UserOs.windows
        ? [DriverTypes.win_sw_setup]
        : easystartpro
        ? [DriverTypes.mac_easy_start_pro]
        : [DriverTypes.mac_sw_setup]
    return this._fetchDriverDownloadUrl(url, driverTypePreference)
  }
}
